import React from "react";
import "./declare-html-microdata-attributes";
import { Style } from "gc-types";
import { StyleItem } from "./StyleItem";
import { microDataAttributeGenerator } from "./microDataAttribute";
import { CollectionDesignation } from "../interfaces";

interface StyleItemsProps {
  styles: Style[];
  totalCount: number;
  lazyLoadAfterImages: number;
  tag?: (styleItem: Style, collectionDesignation: CollectionDesignation) => string | undefined;
  camelCaseMicroData?: boolean;
  withStyleImageCarousels: boolean;
  hashUrl: string;
  collectionDesignation: CollectionDesignation;
}

export const StyleItems: React.FC<StyleItemsProps> = ({
  styles,
  totalCount,
  lazyLoadAfterImages,
  tag,
  camelCaseMicroData,
  withStyleImageCarousels,
  hashUrl,
  collectionDesignation
}) => {
  const microdata = microDataAttributeGenerator(!!camelCaseMicroData);

  return (
    <div
      className="row multi-columns-row mt-40"
      id="product-list"
      {...microdata("itemScope", true)}
      {...microdata("itemType", "http://schema.org/ItemList")}
      data-app="catalogue"
    >
      {styles.map((styleModel: Style, index) => {
        const lazyLoadAllImages = index + 1 > lazyLoadAfterImages;
        return (
          <StyleItem
            hashUrl={hashUrl}
            key={index}
            position={index + 1}
            styleItem={styleModel}
            lazyLoadAllImages={lazyLoadAllImages}
            tag={tag}
            camelCaseMicroData={camelCaseMicroData}
            withStyleImageCarousels={withStyleImageCarousels}
            collectionDesignation={collectionDesignation}
          />
        );
      })}
      <meta {...microdata("itemProp", "numberOfItems")} content={`${totalCount}`} />
      <script dangerouslySetInnerHTML={{ __html: "GlamCornerCore.bus.broadcast('product-list-loaded', {});" }} />
    </div>
  );
};
